export default {
    zh: "简体中文",
    en: "English",
    "my": "မြန်မာ",
    "pt": "Português",
    fr: "français",
    sw: "kiswahili", 
    ha: "Hausa"
}